import { useLocation } from 'react-router-dom';
import { Button } from '../ui/button-comp';
import { useHeaderStore } from './header-store';
import { useContext } from 'react';
import { FormContext } from '../form/form-context';
import { useResolveNavigate } from '../../hooks/use-resolve-navigate';

export function HeaderActionButton() {
	const headerActionButtonText = useHeaderStore((state) => state.headerActionButtonText);
	const headerActionButtonLocation = useHeaderStore((state) => state.headerActionButtonLocation);
	const resolveNavigate = useResolveNavigate();
	const location = useLocation();

	// Check if we're in a form context by using useContext directly
	const formContext = useContext(FormContext);

	const handleClick = () => {
		// If we're on a form page and the button is for saving, trigger the form save
		if (
			formContext && 
			headerActionButtonText === 'Salvar' && 
			(location.pathname === '/relatorios/criar' || 
			 location.pathname.startsWith('/relatorios/editar/') ||
			 location.pathname === '/projetos/criar' ||
			 location.pathname.startsWith('/projetos/editar/'))
		) {
			formContext.triggerSave();
		} else {
			resolveNavigate({ path: headerActionButtonLocation });
		}
	};

	return (
		<Button
			className={``}
			variant={'outline'}
			onClick={handleClick}>
			{headerActionButtonText}
		</Button>
	);
}
